module.exports = __webpack_public_path__ + "static/media/andrew-clark-optimized.bc3f576b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-blazing-fast/images/andrew-clark-optimized.jpg
// module id = 930
// module chunks = 0